//
// Accordion component
//

import { component as defineComponent } from 'flightjs';

function accordion() {
    this.attributes({
        accordionHeaderSelector: '[data-accordion-header]',
        accordionBodySelector: '[data-accordion-body]',
    });

    this.after('initialize', function() {
        this.on('click', {
            accordionHeaderSelector: this.toggleAccordion,
        });

        if (!this.isCollapsed()) {
            this.select('accordionBodySelector').show();
        }
    });

    this.toggleAccordion = function() {
        if (this.isCollapsed()) {
            this.$node.removeAttr('data-accordion-collapse');
            this.openAccordion();
        } else {
            this.$node.attr('data-accordion-collapse', true);
            this.closeAccordion();
        }
    };

    this.isCollapsed = function() {
        return this.$node[0].hasAttribute('data-accordion-collapse');
    };

    this.openAccordion = function() {
        this.select('accordionBodySelector').slideDown();
    };

    this.closeAccordion = function() {
        this.select('accordionBodySelector').slideUp();
    };
}

export default defineComponent(accordion);



// WEBPACK FOOTER //
// ./src/web/js/app/ui/accordion.js